<template>
  <div id="page-campaign-list">
    <div>
      <vs-button @click="addCampaigns" type="border" class="mb-6">{{
        this.$t("Advertiser.AddCampaigns")
      }}</vs-button>
      <div class="flex flex-wrap items-center">
        <dx-data-grid
          class="dx-card wide-card"
          :data-source="customDataSource"
          :focused-row-index="0"
          :show-borders="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="true"
          @editing-start="onEditingStart"
          :ref="gridRefKey"
        >
          >
          <dx-paging :page-size="20" />
          <dx-editing
            :allow-updating="true"
            :use-icons="true"
            :allow-deleting="true"
            mode="popup"
          >
            <dx-grid-popup
              :show-title="true"
              :width="600"
              height="auto"
              :title="$t('Campaign.Edit')"
            >
              <dx-position my="center" at="center" of="window" />
            </dx-grid-popup>
            <dx-form>
              <dx-item
                :col-count="1"
                :col-span="2"
                item-type="group"
                :caption="$t('Settings')"
              >
                <dx-item data-field="isActive" />
                <dx-item data-field="isPremium" />
                <dx-item data-field="hasStrategies" />
                <dx-item data-field="hasSubscriptions" />
                <dx-item data-field="retailerCanBuySubscription" />
                <dx-item data-field="advertiserCanAddSubscription" />
                <dx-item :col-count="2" :col-span="2" item-type="group">
                  <dx-item data-field="name" :col-span="2" />
                  <dx-item data-field="idStrategyType" :col-span="2" />
                </dx-item>
              </dx-item>
            </dx-form>
          </dx-editing>
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <dx-filter-row :visible="true" />
          <dx-column :width="110" :buttons="editButtons" type="buttons" />
          <dx-column
            data-field="id"
            caption="Id"
            data-type="number"
            :width="110"
            :hiding-priority="1"
            :visible="true"
          />

          <dx-column
            data-field="campaignId"
            :caption="$t('Campaign.CampaignId')"
            :hiding-priority="2"
            :visible="true"
            :width="110"
          />
          <dx-column
            data-field="name"
            :caption="$t('Campaign.Name')"
            :hiding-priority="99"
          />
          <dx-column
            data-field="isActive"
            :caption="$t('Campaign.IsActive')"
            :width="190"
            :hiding-priority="7"
            data-type="boolean"
          />
          <dx-column
            data-field="isPremium"
            :caption="this.$t('Campaign.IsPremium')"
            :width="190"
            :hiding-priority="6"
          />
          <dx-column
            data-field="hasSubscriptions"
            :caption="this.$t('Campaign.HasSubscriptions')"
            :width="190"
            :hiding-priority="6"
            :visible="false"
          />
          <dx-column
            data-field="hasStrategies"
            :caption="this.$t('Campaign.HasStrategies')"
            :width="190"
            :hiding-priority="6"
            :visible="false"
          />
          <dx-column
            data-field="advertiserCanAddSubscription"
            :caption="this.$t('Campaign.AdvertiserCanAddSubscription')"
            :width="190"
            :hiding-priority="6"
            :visible="false"
          />
          <dx-column
            data-field="retailerCanBuySubscription"
            :caption="this.$t('Campaign.RetailerCanBuySubscription')"
            :width="190"
            :hiding-priority="6"
            :visible="false"
          />

          <dx-column
            data-field="idStrategyType"
            :caption="this.$t('Campaign.StrategyType')"
            :hiding-priority="7"
            :width="200"
          >
            <dx-lookup
              display-expr="description"
              value-expr="id"
              :data-source="strategyTypes"
            />
          </dx-column>
        </dx-data-grid>
      </div>
    </div>
    <dx-popup
      :title="this.$t('Advertiser.AddCampaigns')"
      v-bind:visible.sync="addCampaignsPopupActive"
      :width="600"
      height="auto"
      :drag-enabled="true"
      :close-on-outside-click="true"
      :show-close-button="false"
      :show-title="true"
    >
      <campaign-add
        :showPopup.sync="addCampaignsPopupActive"
        :idAdvertiser="idAdvertiser"
      />
    </dx-popup>
  </div>
</template>

<script>
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import CustomStore from 'devextreme/data/custom_store'
import CampaignAdd from './CampaignAdd'
import { DxPopup } from 'devextreme-vue/popup'
import { notifyMixin } from '@/mixins/notifyMixin'

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxPaging,
  DxEditing,
  DxPosition,
  DxForm,
  DxPopup as DxGridPopup
} from 'devextreme-vue/data-grid'

import { DxItem } from 'devextreme-vue/form'
let _this = null
const gridRefKey = "grid-campaigns"
export default {
  name: 'campaign-list',
  mixins: [notifyMixin],
  props: {
    idAdvertiser: {
      type: Number
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxPaging,
    DxEditing,
    DxPopup,
    DxPosition,
    DxForm,
    DxItem,
    DxGridPopup,
    CampaignAdd
  },
  data () {
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        return this.$store
          .dispatch(
            'campaignManagement/fetchCampaignsByAdvertiser',
            this.idAdvertiser
          )
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      update: (key, values) => {
        return this.$store
          .dispatch('campaignManagement/saveCampaign', {
            id: key,
            ...values
          })
          .then(() => {
            this.notifySuccess(this.$t('RecordUpdated'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      },
      remove: (key) => {
        return this.$store
          .dispatch('campaignManagement/removeRecord', key)
          .then(() => {
            this.notifySuccess(this.$t('RecordDeleted'))
          })
          .catch((error) => {
            this.notifyError(error)
          })
      }
    })

    const editButtons = ['edit', 'delete']

    return {
      addCampaignsPopupActive: false,
      customDataSource,
      gridRefKey,
      editButtons,
      hasStrategies: false,
      rowKey: -1
    }
  },
  watch: {
    addCampaignsPopupActive: function (val) {
      console.log(`addCampaignsPopupActive changed to ${val}`)
      if (!val) {
        this.refreshGrid()
      }
    }
  },
  computed: {
    strategyTypes () {
      return this.$store.state.refCodes.strategyTypes.map(a => {
        return { ...a, description: this.$t(`StrategyTypeList.${a.description}`) }
      })
    },
    dataGrid: function () {
      return this.$refs[this.gridRefKey].instance
    }
  },
  methods: {
    addCampaigns () {
      this.$vs.loading()
      this.$store
        .dispatch(
          'campaignManagement/fetchUnmappedCampaigns',
          this.idAdvertiser
        )
        .then(() => {
          this.addCampaignsPopupActive = true
          this.$vs.loading.close()
        })
        .catch((error) => {
          this.notifyError(error)
          this.$vs.loading.close()
        })
    },
    refreshGrid () {
      const grid = this.$refs[gridRefKey].instance
      grid.refresh()
    },
    onEditingStart (e) {
      this.rowKey = e.key
    }
  },
  mounted () { },
  created () {
    _this = this
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        'campaignManagement',
        moduleCampaignManagement
      )
      moduleCampaignManagement.isRegistered = true
    }

  }
}
</script>
